import { createSelector } from "reselect";

export const isLoadingEstablishments = (state) =>
  state.establishment?.loadingEstablishments;

export const selectEstablishments = (state) =>
  state.establishment?.establishments;

export const selectEstablishmentById = createSelector(
  [(state, props) => props.identifier, selectEstablishments],
  (establishmentId, establishments) => {
    if (!establishments || establishments.length === 0) return false;
    if (!establishmentId) return undefined;
    return establishments.find(
      (establishment) => establishment.principalId === establishmentId,
    );
  },
);
